<template>
  <v-dialog v-model="show" max-width="700px">
    <v-card>
        <v-card color="#FFD375" class="elevation-12">
            <v-toolbar color="#FFA500">

                <div style="position:absolute; top:8px; left:30px; width:80px;" class="boldtext">Plan</div>
                <div style="position:absolute; top:8px; left:190px; width:100px;" class="boldtext">Cost</div>
                <div style="position:absolute; top:8px; left:305px; width:100px;" class="boldtext">Download</div>
                <div style="position:absolute; top:8px; left:415px; width:100px;" class="boldtext">Storage</div>
                <div style="position:absolute; top:8px; left:510px; width:100px;" class="boldtext">Contacts</div>
                <div style="position:absolute; top:32px; left:190px; width:100px;" class="subtext">{{coststring}}</div>
                <div style="position:absolute; top:32px; left:305px; width:100px;" class="subtext">(MB/month)</div>
                <div style="position:absolute; top:32px; left:415px; width:100px;" class="subtext">(MB)</div>

            </v-toolbar>

            <v-card class="pa-0 ma-0" flat style="width: 100%" tile>
                <v-list :key="this.$store.state.updatecount" two-line class="bckgrnd pa-0 ma-0" flat>
                    <v-content>
                        <v-list-item-group color="#FFD375">
                            <v-list-item v-for="(dat, i) in plans" :key="i">
                                <v-row :class="rowcolor(i)" @click='rowClicked(i)'>
                                    <v-col cols="3">
                                        <v-list-item-content>
                                            <v-list-item-title class="boldtext" v-text="dat.Name"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-list-item-content>
                                            <v-list-item-title :class="rowstyle(i)" v-text="dat.Cost"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-list-item-content>
                                            <v-list-item-title :class="rowstyle(i)" v-text="dat.Bandwidth"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-list-item-content>
                                            <v-list-item-title :class="rowstyle(i)" v-text="dat.Storage"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-list-item-content>
                                            <v-list-item-title :class="rowstyle(i)" v-text="dat.Contacts"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-list-item-icon class="px-2 py-0 ma-0" v-if="chosenplan(i)" @click='changePlanClicked(i)'>
                                            <v-icon color="#000000">swap_horizontal_circle</v-icon>
                                        </v-list-item-icon>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </v-list-item-group>
                    </v-content>
                </v-list>
            </v-card>

            <v-card-actions>
                <v-btn color="#FFA500" @click="cancel" data-cy="joinSubmitBtn">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-card>

    <PaymentPopup v-bind:selectedplan=selectedplan v-model="showPaymentPopup" />

  </v-dialog>
</template>

<script>

    import PaymentPopup from '@/views/Settings/PaymentPopup';
import firebase from 'firebase';

export default {
  props: {
     value: Boolean
        },
    components: {
        PaymentPopup
    },
  data() {
      return {
          plans: [],
          gotplans: false,
          changed: false,
          plan: this.selectedplan,
          title: "Choose Plan...",
          coststring: "(\xA3/month)",
          modal: false,
          chosenplanid: 0,
          selectedplanid: 0,
          selectedplan:null,
          showPaymentPopup: false
      };
  },
  computed: {
    show: {
      get () {
        this.plan = this.selectedplan;
        this.initialiseData();
        return this.value
      },
      set (value) {
         this.$emit('input', value)
          }
      },
    paymentconfirmed() {
        return this.$store.state.paymentconfirmed;
        }
    },
watch: {
    paymentconfirmed() {
        if (this.$store.state.paymentconfirmed) {
            this.changePlan();
        }
    },
},
    methods: {
        changePlan() {

        },
      initialiseData() {
          if (!this.gotplans) {
              this.selectedplan = this.$store.state.useraccount.billing.Plan;
              var plansRef = firebase.database().ref('plans');
              var thisthis = this;
              plansRef.on("value", function (snapshot) {
                  if (snapshot.exists()) {
                      thisthis.gotplans = true;
                      snapshot.forEach(function (child) {
                          //child.key and child.val()
                          //alert(child.key);
                          if (child.key == "Free") {
                              thisthis.plans[0] = { Name: "Free", Cost: child.val().Cost, Bandwidth: child.val().Bandwidth, Storage: child.val().Storage, Contacts: child.val().Contacts };
                              if (thisthis.selectedplan.Name === "Free") { thisthis.selectedplanid = 0; thisthis.chosenplanid = 0;}
                          }
                          if (child.key == "Standard") {
                              thisthis.plans[1] = { Name: "Standard", Cost: child.val().Cost, Bandwidth: child.val().Bandwidth, Storage: child.val().Storage, Contacts: child.val().Contacts };
                              if (thisthis.selectedplan.Name === "Standard") { thisthis.selectedplanid = 1; thisthis.chosenplanid = 1;}
                          }
                          if (child.key == "Professional") {
                              thisthis.plans[2] = { Name: "Professional", Cost: child.val().Cost, Bandwidth: child.val().Bandwidth, Storage: child.val().Storage, Contacts: child.val().Contacts };
                              if (thisthis.selectedplan.Name === "Professional") { thisthis.selectedplanid = 2; thisthis.chosenplanid = 2;}
                          }
                      });
                  }
              });
          }
      },
      changePlan() {
          var plan = this.plans[this.chosenplanid];
          var pln = { Bandwidth: plan.Bandwidth, Cost: plan.Cost, Name: plan.Name, Storage:plan.Storage, Contacts:plan.Contacts };
          firebase.database().ref('useraccounts/' + this.$store.state.user.uid + "/billing/Plan").set(pln);
          this.show = false;
      },
      rowClicked(i) {
          this.chosenplanid = i;
      },
      changePlanClicked(i) {
          this.$store.state.paymentconfirmed = false;
          this.showPaymentPopup = true;
      },
      rowstyle(i) {
          if (i == this.selectedplanid)
              return 'boldtext';
          else {
              return 'normaltext';
          }
      },
      rowcolor(i) {
          if (this.plans[i].Name === this.selectedplan.Name)
              return "greentile";
          if (i == this.chosenplanid)
              return "chosentile";
          return "normaltile";
      },
      chosenplan(i) {
          if (i == this.selectedplanid) return false;
          if (i == this.chosenplanid) return true;
          return false;
      },
      cancel(){
          this.show=false;
      },
      submit() {
          this.show=false;
      }
  }
}
</script>

<style scoped>
    .bckgrnd {
        background: #FFD375;
    }

    .boldtext {
        color: black;
        font-size: large;
        font-weight: bold;
    }

    .subtext {
        color: black;
        font-size:small;
    }

    .normaltext {
        color: black;
    }

    .row-pointer > tbody tr :hover {
        cursor: pointer;
    }

    .normaltile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        border-color: black;
        background: #FFD375;
    }

    .greentile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        background: #86F499;
    }

    .chosentile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        background: #FFA500;
    }

</style>